export const appConfig = { ...window._env_ };
